import React from 'react';

const Filler = () => {
    return (
        <div className='w-full bg-transparent backdrop-blur-sm py-6 px-4 mx-auto text-center flex flex-col justify-center'></div>
      );
    };
export default Filler;